<script setup>
    import { ref, onMounted, watch } from 'vue'
    //import { useRoute, useRouter } from 'vue-router'
    import DropDown from "@/components/common/DropDownSelect.vue"

    const version = __APP_VERSION__

    //properties set by parent
    const selectedDataVersion = ref('')
    const currentDataVersion = ref('')
    const dataVersions = ref([])
    const pufs = ref([])

    async function fetchData() {
        const apiUrl = import.meta.env.VITE_API_URL;

        let url = apiUrl + '/indicators/api/dataversions'
        let response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-api-version': version
                }
            }
        )
        if (!response.ok) {
            throw new Error(`HTTP status: ${response.status}`);
        }
        return await response.json()
    }
    async function startup() {
        let results  = await fetchData();
        let n = results.items.length
        dataVersions.value = results.items
        selectedDataVersion.value = dataVersions.value[n-1].version
        currentDataVersion.value = selectedDataVersion.value
        getTableData(selectedDataVersion.value)
        return true
    }
    function Puf(reference, indicator, datafilepath, datafilesize, cbfilepath, cbfilesize, tnfilepath, tnfilesize, bundlefilepath, bundlefilesize) {
        this.reference = reference;
        this.indicator = indicator;
        //http://localhost:5173/indicators/explorer/indicatorsexplorer?iname=Computer%2520and%2520Information%2520Literacy%2520(ICILS)
        //this.indicator = '<a class="link" href="' + import.meta.env.VITE_BASE_URL + '/indicatorsexplorer?iname=' + encodeURIComponent(indicator) + '>' + indicator + '</a>';
        this.href = import.meta.env.VITE_BASE_URL + '/indicatorsexplorer?iname=' + encodeURIComponent(indicator);
        this.datafilepath = datafilepath;
        this.datafilesize = datafilesize;
        this.cbfilepath = cbfilepath;
        this.cbfilesize = cbfilesize;
        this.tnfilepath = tnfilepath;
        this.tnfilesize = tnfilesize;
        this.bundlefilepath = bundlefilepath;
        this.bundlefilesize = bundlefilesize;
    }
    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        
        // Calculate the appropriate index for the 'sizes' array using logarithms
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        // Format the number to the desired decimal places and append the unit
        return `${Number.parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))} ${sizes[i]}`;
    }
    async function getTableData(table) {
        //let path = '/indicators/explorer/public/download/' + selectedDataVersion.value + '/index.json';
		selectedDataVersion.value = table
        let path = 'download/' + selectedDataVersion.value + '/index.json';
        pufs.value = [];
        try {
            const response = await fetch(path); // Path relative to the public directory
            const data = await response.json();            
            let availableData = Object.entries(data);
            if(import.meta.env.VITE_APP_DEBUG)
                console.log('availableData',availableData)

	        for(let b = 0; b < availableData.length; b++) {
                //data_filepath:
                let datafileitem = availableData[b][1].data_filepath
                let datafile = []
                let datafilepath = 'undefined'
                let datafilesize = '';
                if(datafileitem) {
                    datafile = datafileitem.split('|',3)
                    datafilepath = 'download/' + selectedDataVersion.value + '/' + datafile[0] + '/' + datafile[1];
                    if(datafile[2]) {
                        datafilesize = formatBytes(datafile[2],0);
                    }
                }
                //codebook_file:
                let cbfileitem = availableData[b][1].codebook_file
                let cbfile = []
                let cbfilepath = 'undefined'
                let cbfilesize = '';
                if(cbfileitem) {
                    cbfile = cbfileitem.split('|',3)
                    cbfilepath = 'download/' + selectedDataVersion.value + '/' + cbfile[0] + '/' + cbfile[1];
                    if(cbfile[2]) {
                        cbfilesize = formatBytes(cbfile[2],0);
                    }
                }
                //technotes_file:
                let tnfileitem = availableData[b][1].technotes_file
                let tnfile = []
                let tnfilepath = 'undefined'
                let tnfilesize = '';
                if(tnfileitem) {
                    tnfile = tnfileitem.split('|',3)
                    tnfilepath = 'download/' + selectedDataVersion.value + '/' + tnfile[0] + '/' + tnfile[1];
                    if(tnfile[2]) {
                        tnfilesize = formatBytes(tnfile[2],0);
                    }
                }
                //bundle_file:
                let bundlefileitem = availableData[b][1].bundle_file
                let bundlefile = []
                let bundlefilepath = 'undefined'
                let bundlefilesize = '';
                if(bundlefileitem) {
                    bundlefile = bundlefileitem.split('|',3)
                    bundlefilepath = 'download/' + selectedDataVersion.value + '/' + bundlefile[0] + '/' + bundlefile[1];
                    if(bundlefile[2]) {
                        bundlefilesize = formatBytes(bundlefile[2],0);
                    }
                }
                const pufRecord = new Puf(b+1, availableData[b][0], datafilepath, datafilesize, cbfilepath, cbfilesize, tnfilepath, tnfilesize, bundlefilepath, bundlefilesize);
                pufs.value.push(pufRecord)
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    onMounted(() => {
        startup();
        
        // Digital Analytics Program (https://digital.gov/guides/dap) 
        if(import.meta.env.VITE_APP_ENV && import.meta.env.VITE_APP_ENV === 'production') {
            const dapScript = document.createElement("script");
                dapScript.setAttribute("async", "")
                dapScript.setAttribute("id","_fed_an_ua_tag");
                dapScript.setAttribute("type","text/javascript");
                dapScript.setAttribute("src","https://dap.digitalgov.gov/Universal-Federated-Analytics-Min.js?agency=NSF");
            document.head.appendChild(dapScript);
        }

    })


</script>

<template>
    <section class="page-container">
        <div class="page-contents">
            <h2 class="title">Downloads</h2>
            <div class="separator-line"></div>
            <p class="description">Access and download complete datasets in CSV format. Use these files for your own analysis, reporting, or research. Choose a dataset to get started.</p>

            <div class="">
				<div>
					<div class="subtle-label">Data Version</div>
				</div>
				<div class="version-select">
					<DropDown v-model="selectedDataVersion" :list="dataVersions" :keyField="'version'"  @selectedDropdown="getTableData"  />				
				</div>
			</div>

            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Reference</th>
                            <th>Indicator</th>
                            <th>Data (CSV)</th>
                            <th>Codebook (PDF)</th>
                            <th>Data Notes (PDF)</th>
                            <th>Bundle</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- Loop through the users array and create a table row for each user -->
                        <tr v-for="puf in pufs" :key="puf.reference">
                            <td data-label="Reference">{{ puf.reference }}</td>
                            <td data-label="Indicator" :class="currentDataVersion === selectedDataVersion ? 'indicators-link' : ''">
                                <span v-if="currentDataVersion === selectedDataVersion">
                                    <a class="indicators-link" :href=puf.href>{{  puf.indicator  }}</a>
                                </span>
                                <span v-else>{{  puf.indicator  }}</span>
                            </td>
                            <td data-label="Data (CSV)">
                                <a v-if="!puf.datafilepath.endsWith('undefined')" class="indicators-link" :title=encodeURI(puf.datafilepath) :href=encodeURI(puf.datafilepath) download>
                                    <i class="fa-solid f fa-file-csv"></i> <span class="indicators-filesize">{{ puf.datafilesize }}</span>
                                </a>
                            </td>
                            <td data-label="Codebook (PDF)">
                                <a v-if="!puf.cbfilepath.endsWith('undefined')" class="indicators-link" :href=encodeURI(puf.cbfilepath) download>
                                    <i class="fa-solid f fa-file-pdf"></i> <span v-show="puf.cbfilesize !== null" class="indicators-filesize">{{ puf.cbfilesize }}</span>
                                </a>
                            </td>
                            <td data-label="Tech Notes (PDF)">
                                <a v-if="!puf.tnfilepath.endsWith('undefined')" class="indicators-link" :href=encodeURI(puf.tnfilepath) download>
                                    <i class="fa-solid f fa-file-pdf"></i> <span class="indicators-filesize">{{ puf.tnfilesize }}</span>
                                </a>
                            </td>
                            <td data-label="Bundle">
                                <a v-if="!puf.bundlefilepath.endsWith('undefined')" class="indicators-link" :href=encodeURI(puf.bundlefilepath) download>
                                    <i class="fa-solid f fa-folder"></i> <span class="indicators-filesize">{{ puf.bundlefilesize }}</span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </section>
</template>

<style scoped>
.page-container {
    /*display: block;*/
    display: flex;
	flex-direction: column;
	flex-grow: 1;
	flex-shrink: 1;
  	min-width: 0;      /* Crucial for row layouts to allow shrinking */
  	min-height: 0;     /* Crucial for column layouts to allow shrinking */
    /*min-width: 375px;*/
    width: 100%;
    height: 100%;
    transition: max-width .2s linear;
    border-radius: 0.75rem;
    background-color: var(--surface-color-Default, #fff);
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.10);
    line-height: 1.5;
    background-color: var(--surface-color-Default, #fff);
}
.page-contents {
    padding: var(--spacing-7xl) var(--spacing-4xl) 0;
    margin-bottom: 1.5rem;
}
.title {
    font-size: var(--font-size-H2);
    font-family: var(--font-family-Title, Roboto);
    font-weight: 500;
    color: var(--text-text-Header);
    line-height: var(--font-line-height-H2);
    margin: 0;
}
.separator-line {
    width: 5rem;
    height: 0.375rem;
    background-color: #005495;
    margin: 1.625rem 0;
}
.description {
    color: var(--text-Primary);
    font-family: var(--font-family-Title, Roboto);
    font-size: var(--font-size-Base);
    font-style: normal;
    font-weight: 400;
    line-height: var(--font-line-height-Base);
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 7;
    line-clamp: 7;
    align-self: stretch;
    max-width: 812px;
}
.subtle-label {
    color: var(--text-Secondary);
}
.version-select {
    max-width: 408px;
}
.table-container {
    margin-top: 2rem;
}
.table-container table {
  border-collapse: collapse; /* This is important to prevent double borders or gaps */
  width: 100%;
}
.table-container th {
    position: sticky;
    top: 0;
    line-height: 1.5;
    background-color: var(--surface-color-Secondary);
    height: 2.6875rem;
    gap: .75rem;
    opacity: 1;
    padding-top: .25rem;
    padding-right: .5rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    border-bottom: 1px solid var(--border-color-input-Border); /* Sets the bottom border */
    text-align: left; /* Aligns text to the left */
}
.table-container td {
    line-height: 1.5;
    background-color: var(--surface-color-Default);
    height: 2.6875rem;
    gap: .75rem;
    opacity: 1;
    padding-top: .25rem;
    padding-right: .5rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    border-bottom: 1px solid var(--border-color-input-Border); /* Sets the bottom border */
    text-align: left; /* Aligns text to the left */
    height: 2.7rem;
}
.indicators-link {
    font-weight: 500;
    color: var(--brand-color-IndicatorsBlue);
    text-decoration: none;
    cursor: pointer;
}
.indicators-link:hover {
    text-decoration: underline;
}
.indicators-link i {
    font-size: larger;
}
.indicators-filesize {
    color: var(--text-Secondary);
    text-decoration: none;
    font-weight: 400;
    /*font-family: Roboto;*/
    font-weight: 400;
    font-size: .875rem;
    line-height: 1.25;
    letter-spacing: 0px;
}
.center {
    text-align: center !important;
}
/* Responsive styles for screens smaller than a specific breakpoint (e.g., 600px) */
@media (max-width: 600px) {
  table, thead, tbody, th, td, tr {
    display: block; /* Change display behavior for all table elements */
    table-layout: fixed;
  }
  thead {
    display: none; /* Hide the original header row */
  }
  tr {
    margin-bottom: 0;
    border-top: 1px solid var(--border-color-input-Border); /* Sets the bottom border */
  }
  td {
    display: flex; /* Changed from display: block */
    flex-direction: row;
    padding: .625rem 0 .625rem 0;
    justify-content: space-between; /* Pushes label left and data right */
    height: 2.6875rem;
    gap: .75rem;
    opacity: 1;
    padding-top: .25rem;
    padding-right: .5rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    border-bottom: 1px solid var(--border-color-input-Border); /* Sets the bottom border */
    text-align: center; /* Aligns text to the left */

    overflow: hidden;         /* Hides the overflowing content */
    white-space: nowrap;      /* Prevents text from wrapping to a new line */
    text-overflow: ellipsis;  /* Displays the ellipsis (...) for clipped text */
    align-items: center;
    min-width: 0;
  
  }
  td::before {
    content: attr(data-label);
    color: var(--text-Primary);
    font-size: var(--font-size-Base);
    font-weight: bold;
    text-indent: 1rem;
    margin-right: 1rem; /* Creates a gap between label and data */
    margin-left: -1rem;
    flex-basis: 40%; /* Sets a fixed width for the left side */
    flex-shrink: 0; /* Prevents the label from squishing */
    background-color: var(--surface-color-Secondary);
    text-align: left;
    line-height: 2.6875rem;
    align-items: bottom;
    min-width: 10rem;
  }
}
</style>